import { createAsyncActionType } from './index';

export const GET_DAILY_DATA = createAsyncActionType(
  'dashboard',
  'GET_DAILY_DATA'
);

export const GET_CHARGING_SESSIONS_DATA = createAsyncActionType(
  'dashboard',
  'GET_CHARGING_SESSIONS_DATA'
);

export const GET_CHARGING_POINTS_DATA = createAsyncActionType(
  'dashboard',
  'GET_CHARGING_POINTS_DATA'
);

export const GET_CHARGING_META_DATA = createAsyncActionType(
  'dashboard',
  'GET_CHARGING_META_DATA'
);

export const GET_CHARGING_SESSION_AVERAGE_DATA = createAsyncActionType(
  'dashboard',
  'GET_CHARGING_SESSION_AVERAGE_DATA'
);

export const GET_MAP_DATA = createAsyncActionType('dashboard', 'GET_MAP_DATA');

export const DOWNLOAD_DASHBOARD_DATA = createAsyncActionType(
  'dashboard',
  'DOWNLOAD_DASHBOARD_DATA'
);

export const GET_DRIVERS_STATUS_DATA = createAsyncActionType(
  'dashboard',
  'GET_DRIVERS_STATUS_DATA'
);

export const GET_CONNECTORS_DATA = createAsyncActionType(
  'dashboard',
  'GET_CONNECTORS_DATA'
);

export const GET_CONNECTOR_STATUS_DATA = createAsyncActionType(
  'dashboard',
  'GET_CONNECTOR_STATUS_DATA'
);

export const GET_CHARGERS_MAP_DATA = createAsyncActionType(
  'dashboard',
  'GET_CHARGERS_MAP_DATA'
);

export const GET_DOMAINS_FOR_FILTERS = createAsyncActionType(
  'dashboard',
  'GET_DOMAINS_FOR_FILTERS'
);

export const GET_AVERAGE_DATA_CORPORATE = createAsyncActionType(
  'dashboard',
  'GET_AVERAGE_DATA_CORPORATE'
);

export const GET_CHARGING_SESSION_DATA_CORPORATE = createAsyncActionType(
  'dashboard',
  'GET_CHARGING_SESSION_DATA_CORPORATE'
);

export const GET_CHARGING_META_DATA_CORPORATE = createAsyncActionType(
  'dashboard',
  'GET_CHARGING_META_DATA_CORPORATE'
);

export const GET_LAST_FOTA_CAMPAIGN = createAsyncActionType(
  'dashboard',
  'GET_LAST_FOTA_CAMPAIGN'
);

export const GET_TOTAL_ALARMS_WARNINGS = createAsyncActionType(
  'dashboard',
  'GET_TOTAL_ALARMS_WARNINGS'
);

export const GET_GROUPED_ALARM_TYPES = createAsyncActionType(
  'dashboard',
  'GET_GROUPED_ALARM_TYPES'
);
